<script setup>
// GK-HUB: gk-v1.4.81 — Renderiza chips de reactions de WhatsApp anexadas ao bubble.
// Recebe array `[{from, emoji, ts}]` de content_attributes.reactions.
// Agrupa por emoji e mostra contagem quando >1 do mesmo.
import { computed } from 'vue';

const props = defineProps({
  reactions: { type: Array, default: () => [] },
});

const grouped = computed(() => {
  const map = new Map();
  (props.reactions || []).forEach(r => {
    if (!r?.emoji) return;
    const key = r.emoji;
    if (!map.has(key)) map.set(key, { emoji: key, count: 0, from: [] });
    const entry = map.get(key);
    entry.count += 1;
    entry.from.push(r.from || 'unknown');
  });
  return Array.from(map.values());
});
</script>

<template>
  <div
    v-if="grouped.length"
    class="gk-msg-reactions flex items-center gap-1 mt-1"
  >
    <span
      v-for="r in grouped"
      :key="r.emoji"
      v-tooltip="r.from.join(', ')"
      class="gk-reaction-chip"
    >
      <span class="gk-reaction-emoji">{{ r.emoji }}</span>
      <span v-if="r.count > 1" class="gk-reaction-count">{{ r.count }}</span>
    </span>
  </div>
</template>

<style lang="scss" scoped>
.gk-reaction-chip {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 2px 6px;
  border-radius: 999px;
  font-size: 13px;
  line-height: 1;
  background: var(--n-solid-3, rgba(0, 0, 0, 0.04));
  border: 1px solid var(--n-weak, rgba(0, 0, 0, 0.08));
  cursor: default;
  transition: transform 120ms ease;

  &:hover {
    transform: scale(1.08);
  }
}

.gk-reaction-emoji {
  font-size: 14px;
}

.gk-reaction-count {
  font-size: 11px;
  font-weight: 600;
  color: var(--n-slate-11, #6e6f73);
  padding-left: 2px;
}

body.dark {
  .gk-reaction-chip {
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(255, 255, 255, 0.12);
  }

  .gk-reaction-count {
    color: rgba(255, 255, 255, 0.6);
  }
}
</style>
